export enum ContentTableTypeEnum {
  Playlists = "playlists",
}
